import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { AdminComponent } from './admin.component';
import { AdminRoutingModule } from './admin-routing.module';
import { ClientImpersonationComponent } from './client-impersonation/client-impersonation.component';
import { ClientService } from '../../../shared/services/client.service';
import { CostCenterService } from '../../../shared/services/cost-center.service';
import { FacilityComponent } from './facility/facility.component';
import { FacilityService } from '../../../shared/services/facility.service';
import { JobTitleComponent } from './job-title/job-title.component';
import { JobTitleService } from '../../../shared/services/job-title.service';
import { SmtSharedModule } from '../../../shared/module/shared.module'
import { MeasuresComponent } from './measures/measures.component';
import { MeasureService } from '../../../shared/services/measure.service';
import { StaffingGridService } from 'src/shared/services/staffing-grid.service';
import { TimeZoneService } from 'src/shared/services/time-zone.service';
import { VarianceReasonComponent } from './variance-reason/variance-reason.component';
import { VarianceReasonService } from '../../../shared/services/variance-reason.service';
import { UserComponent } from './user/user.component';
import { UserService } from '../../../shared/services/user.service';
import { UnitsOfServiceComponent } from './units-of-service/units-of-service.component';
import { UnitsOfServiceService } from 'src/shared/services/units-of-service.service';
import { ProcedureComponent } from './procedure/procedure.component';
import {ProcedureService} from 'src/shared/services/procedure.service';
import { ClientConfigurationComponent } from './client-configuration/client-configuration.component';
import { AcuityService } from 'src/shared/services/acuity.service';
import { TimePayCodeMappingComponent } from './imports/time-pay-code-mapping/time-pay-code-mapping.component';
import { CostCenterMappingComponent } from './imports/cost-center-mapping/cost-center-mapping.component';
import { CostCenterMappingService } from 'src/shared/services/cost-center-mapping.service';
import { ImportRoutingModule } from './imports/import-routing.module';
import { ImportComponent } from './imports/import.component';
import { JobTitleMappingComponent } from './imports/job-title-mapping/job-title-mapping.component';
import { JobTitleMappingService } from 'src/shared/services/job-title-mapping.service';
import { TotalUosImportService } from 'src/shared/services/total-uos-import.service';
import { TimeAndAttendanceImportService } from 'src/shared/services/time-and-attendance-import.service';

@NgModule({
  declarations: [
      AdminComponent,
      ClientImpersonationComponent,
      FacilityComponent,
      JobTitleComponent,
      MeasuresComponent,
      VarianceReasonComponent,
      UserComponent,
      UnitsOfServiceComponent,
      ProcedureComponent,
      TimePayCodeMappingComponent,
      CostCenterMappingComponent,
      ClientConfigurationComponent,
      ImportComponent,
      JobTitleMappingComponent
    ],
  imports: [
    AdminRoutingModule,
    CommonModule,
    FormsModule,
    InfiniteScrollModule,
    SmtSharedModule,
    ImportRoutingModule
  ],
  providers: [
      AcuityService,
      ClientService,
      CostCenterService,
      FacilityService,
      JobTitleService,
      MeasureService,
      StaffingGridService,
      TimeZoneService,
      UserService,
      VarianceReasonService,
      UnitsOfServiceService,
      ProcedureService,
      CostCenterMappingService,
      JobTitleMappingService,
      TotalUosImportService,
      TimeAndAttendanceImportService
      ]

})
export class AdminModule { }
